export const DefaultSubscriber = "the-place"

export const QuickNotificationReport  = "QUICK NOTIFICATION"
export const FavouriteReport = "FAVOURITE"